import { PartitionOutlined } from '@ant-design/icons';

import MenuConfigType from '@app/types/MenuConfigType';

/**
 * Top-level Manual Routing tab (IFMDMS-62 / IFMDMS-66).
 * No featureFlag — not a separate product flag.
 * TopMenu only renders items with privileged === true. Until the auth menu API returns
 * key `ManualRouting` (IFMDMS-70), set privileged so the tab is visible locally.
 * When the backend does return that key, mapMenuConfig still marks it privileged from auth.
 */
const manualRoutingMenuConfig: MenuConfigType = {
  path: '/manual-routing/',
  title: 'Manual Routing',
  key: 'ManualRouting',
  icon: PartitionOutlined,
  guard: [],
  privileged: true,
};

export default manualRoutingMenuConfig;
